<template>
  <div>
    <page-outline :title="$t('Webheader.injection_unit')" :accessibilityCompliant="true">
      <template slot="pageContent">
        <div slot="pageContent">
          <div id="error-summary" class="alert alert-danger border-2 p-3 mb-3" role="alert" aria-live="assertive" tabindex="-1" v-if="formErrors.length > 0">
            <h2 class="h5 text-dark mb-2">{{ $t('errors.error_summary') }}</h2>
            <ul class="mb-0 ps-3">
              <li v-for="error in formErrors" :key="error.field">
                <a :href="'#' + error.field" class="text-dark text-decoration-underline">{{ error.message }}</a>
              </li>
            </ul>
          </div>
          <b-container fluid>
          <form-accordion :toggleActive="false"  :title="$t('tracking.general_information')" :isTitleUpperCase="false">
            <h2 class="sr-only">{{ $t('tracking.general_information') }}</h2>
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col cols="12" sm="6" class="mb-3">
                <span>{{ $t('tracking.please_enter_iban_to_verify') }}</span>
                <br>
                <br>
                <br>

                <form-write-group-label-input v-model="form.iban" isMandatory
                  :inputLabel="$t('tracking.iban') + ' ' + $t('tracking.to_check')"
                  :descLabel="$t('tracking.iban_description')"
                  :placeholderValue="$t('tracking.iban')"
                  inputId="iban-input"
                  autocomplete="off">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="12" sm="6" class="mb-3">
                <br>
                <br>
                <br>
                <br>
                <form-write-group-label-input v-if="verifierIBAN(form.iban) && form.iban != '' && corporateIdentifierTypesMatch" v-model="form.reference"
                  :inputLabel="$t('tracking.reference')" :placeholderValue="$t('tracking.reference')"
                  inputId="reference-input">
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <form-accordion v-if="ibanFind" :toggleActive="true"  :title="$t('tracking.information_retrieved_from_iban')" :isTitleUpperCase="false">
            <h2 class="sr-only">{{ $t('tracking.information_retrieved_from_iban') }}</h2>
            <b-row class="d-flex justify-content-center align-items-start">
              <b-col cols="12" md="6" lg="4" class="mb-3">
                <div class="custom-table-container border rounded" tabindex="0" role="region" :aria-label="$t('tracking.valid_iban') + ' - ' + $t('common.scrollable_table')">
                  <table class="table table-bordered table-sm text-center mb-0">
                    <caption class="text-center bg-dark text-white p-2 mb-0">{{ $t('tracking.valid_iban') }}</caption>
                    <thead>
                      <tr>
                        <th id="verification-type-1" scope="col">{{ $t('tracking.verification_type') }}</th>
                        <th id="verification-status-1" scope="col">{{ $t('tracking.status') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.iban_format_verification') }}</th>
                        <td v-if="format == '$Match'" class="align-middle table-success text-dark fw-bold">
                          <i class="fa fa-check-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.valid') }}
                        </td>
                        <td v-else class="align-middle table-danger text-dark fw-bold">
                          <i class="fa fa-times-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.invalid') }}
                        </td>
                      </tr>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.account_key_verification') }}</th>
                        <td v-if="keyIban == '$Match'" class="align-middle table-success text-dark fw-bold">
                          <i class="fa fa-check-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.valid') }}
                        </td>
                        <td v-else class="align-middle table-danger text-dark fw-bold">
                          <i class="fa fa-times-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.invalid') }}
                        </td>
                      </tr>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.iban_key_verification') }}</th>
                        <td v-if="keyBBAN == '$Match'" class="align-middle table-success text-dark fw-bold">
                          <i class="fa fa-check-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.valid') }}
                        </td>
                        <td v-else class="align-middle table-danger text-dark fw-bold">
                          <i class="fa fa-times-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.invalid') }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" class="align-middle">{{ $t('tracking.bank_reachable') }}</th>
                        <td v-if="corporateIdentifierTypesMatch" class="align-middle table-success text-dark fw-bold">
                          <i class="fa fa-check-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.reachable') }}
                        </td>
                        <td v-else class="align-middle table-danger text-dark fw-bold">
                          <i class="fa fa-times-circle me-1" aria-hidden="true"></i>
                          {{ $t('common.unreachable') }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
              <b-col cols="12" md="6" lg="4" class="mb-3">
                <div class="custom-table-container border rounded" tabindex="0" role="region" :aria-label="$t('tracking.bank_domiciliation') + ' - ' + $t('common.scrollable_table')">
                  <table class="table table-bordered table-sm text-center mb-0">
                    <caption class="text-center bg-dark text-white p-2 mb-0">{{ $t('tracking.bank_domiciliation') }}</caption>
                    <thead>
                      <tr>
                        <th id="bank-info-type" scope="col">{{ $t('tracking.information_type') }}</th>
                        <th id="bank-info-value" scope="col">{{ $t('tracking.value') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.institution_name') }}</th>
                        <td v-if="institutionName !== '' && institutionName !== '$NotFound'" class="align-middle" id="InstitutionName">{{ institutionName }}</td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.branch_information') }}</th>
                        <td v-if="branchInformation !== '' && branchInformation !== '$NotFound'" class="align-middle" id="BranchInformation">{{ branchInformation }}</td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.address_line_1') }}</th>
                        <td v-if="address1 !== '' && address1 !== '$NotFound'" class="align-middle" id="StreetAddress1">{{ address1 }}</td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr v-if="address2 !== '' && address2 !== '$NotFound'" style="background-color: #F9F9F9">
                        <th scope="row" class="align-middle">{{ $t('tracking.address_line_2') }}</th>
                        <td class="align-middle" id="StreetAddress2">{{ address2 }}</td>
                      </tr>
                      <tr v-if="address3 !== '' && address3 !== '$NotFound'" style="background-color: #F9F9F9">
                        <th scope="row" class="align-middle">{{ $t('tracking.address_line_3') }}</th>
                        <td class="align-middle" id="StreetAddress3">{{ address3 }}</td>
                      </tr>
                      <tr v-if="address4 !== '' && address4 !== '$NotFound'" style="background-color: #F9F9F9">
                        <th scope="row" class="align-middle">{{ $t('tracking.address_line_4') }}</th>
                        <td class="align-middle" id="StreetAddress4">{{ address4 }}</td>
                      </tr>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.zip_and_city') }}</th>
                        <td v-if="(zipCode !== '' && zipCode !== '$NotFound') || (city !== ''  && city !== '$NotFound')" class="align-middle" id="ZipCodeCity"><span id="ZipCode">{{ zipCode }}</span><span>&nbsp;</span><span id="City">{{ city }}</span></td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr v-if="Cps !== '' && Cps !== '$NotFound'" style="background-color: #F9F9F9">
                        <th scope="row" class="align-middle">{{ $t('tracking.cps') }}</th>
                        <td class="align-middle" id="Cps">{{ Cps }}</td>
                      </tr>
                      <tr class="bg-light">
                        <th scope="row" class="align-middle">{{ $t('tracking.country_and_iso') }}</th>
                        <td v-if="(country !== '' && country !== '$NotFound') || (ISOCountryCode !== '' && ISOCountryCode !== '$NotFound')" class="align-middle" id="CountryNameAndIso"><span id="CountryName">{{ country }}</span>&nbsp;<span v-if="ISOCountryCode !== '$NotFound'">(<span id="IsoCountryCode">{{ ISOCountryCode }}</span>)</span></td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
              <b-col cols="12" md="6" lg="4" class="mb-3">
                <div class="custom-table-container border rounded" tabindex="0" role="region" :aria-label="$t('tracking.iban_composition') + ' - ' + $t('common.scrollable_table')">
                  <table class="table table-bordered table-sm text-center mb-0">
                    <caption class="text-center bg-dark text-white p-2 mb-0">{{ $t('tracking.iban_composition') }}</caption>
                    <thead>
                      <tr>
                        <th id="iban-component-type" scope="col">{{ $t('tracking.component_type') }}</th>
                        <th id="iban-component-value" scope="col">{{ $t('tracking.value') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr style="background-color: #F9F9F9">
                      <th scope="row" class="align-middle">{{ $t('tracking.bank_code') }}</th>
                      <td class="align-middle">{{ IDBank === '$NotFound' ? '-': IDBank}}</td>
                    </tr>
                    <tr style="background-color: #F9F9F9">
                      <th scope="row" class="align-middle">{{ $t('tracking.branch_code') }}</th>
                      <td class="align-middle">{{ IDBranch === '$NotFound' ? '-': IDBranch}}</td>
                    </tr>
                    <tr style="background-color: #F9F9F9">
                      <th scope="row" class="align-middle">{{ $t('tracking.account_number') }}</th>
                      <td class="align-middle">{{ accountNumber === '$NotFound' ? '-': accountNumber}}</td>
                    </tr>
                    <tr>
                      <th scope="row" class="align-middle"><span lang="en">{{ $t('tracking.bic') }}</span></th>
                      <td class="align-middle">{{ parentBic === '$NotFound' ? '-': parentBic }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </form-accordion>
          <form-accordion :toggleActive="false" v-if="verifierIBAN(form.iban) && form.iban !== '' && corporateIdentifierTypesMatch" :title="$t('tracking.data_to_check')" :isTitleUpperCase="false">
            <h2 class="sr-only">{{ $t('tracking.data_to_check') }}</h2>
            <fieldset class="border-0 m-0 p-0">
              <legend class="sr-only fw-bold">{{ $t('tracking.enterprise_identification') }}</legend>
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col cols="12" sm="6" class="mb-3">
                  <label for="identifier-type" id="identifier-type-label">
                    {{ $t('tracking.type_identifier') }}<span class="text-dark"> * </span>
                  </label>
                  <select 
                    id="identifier-type" 
                    class="form-control" 
                    v-model="form.entrepriseIdentifierType" 
                    :required="verifierIBAN(form.iban) && form.iban !== ''" 
                    :disabled="!verifierIBAN(form.iban) || form.iban === ''"
                    :aria-describedby="hasIdentifierTypeError ? 'identifier-type-error' : null"
                    :aria-invalid="hasIdentifierTypeError ? 'true' : 'false'"
                    :aria-required="verifierIBAN(form.iban) && form.iban !== '' ? 'true' : 'false'"
                    autocomplete="organization">
                    <option value=""> {{ $t('common.nme') }} </option>
                    <option v-for="type in Object.keys(typeList).filter(elem => !typeList[elem])" :key="type" :value="type">
                      {{ type }}
                    </option>
                  </select>
                  <div v-if="hasIdentifierTypeError" id="identifier-type-error" class="text-dark small mt-1" role="alert" aria-live="polite">
                    {{ identifierTypeErrors[0].message }}
                  </div>
                </b-col>
                <b-col cols="12" sm="6" class="mb-3">
                  <form-write-group-label-input v-model="form.entrepriseIdentifierName" isMandatory :disabled="!verifierIBAN(form.iban) || form.iban == ''"
                    :inputLabel="$t('tracking.identifier')" :placeholderValue="$t('tracking.identifier')"
                    inputId="identifier-input"
                    :mandatoryErrorIndicator="hasIdentifierInputError">
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="12" sm="6" class="mb-3">
                </b-col>
              </b-row>
            </fieldset>
          </form-accordion>

          <b-row class="mt-4">
            <b-col cols="12">
              <button 
                type="button"
                class="btn btn-lg btn-block w-100"
                :class="{
                  'btn-turquoise': !activateSpinner && isFormValid,
                  'btn-turquoise-disabled': !isFormValid || activateSpinner
                }"
                @click="addTracking" 
                :disabled="!isFormValid || activateSpinner"
                :aria-busy="activateSpinner ? 'true' : 'false'">
                <b-spinner 
                  v-if="activateSpinner" 
                  small 
                  style="color: #ffffff;">
                </b-spinner>
                <i 
                  v-else 
                  class="fa-light fa-paper-plane" 
                  style="color: #ffffff;"
                  aria-hidden="true">
                </i>
                {{ ' ' }}{{ $t('common.send_verification_request') }}
              </button>
            </b-col>
          </b-row>
        </b-container>
        </div>
      </template>
    </page-outline>
  </div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from "@/components/common/PageOutline.vue";
import {loadPage} from "@/helpers/routing";
import {errorMessageAlert} from "@/helpers/alert";
import moment from "moment/moment";
import {downloadFileWithDefinedHeaders} from "@/helpers/download";
import conf from '../../config/config.dev.js'

export default {
  name: 'TrackingForm',
  components: {
    PageOutline,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      flagCACP: conf.visual != 'CACP' ? false : true,
      activateSpinner: false,
      ibanFind: false,
      corporateIdentifierTypesMatch: false,
      formErrors: [],
      format: '',
      keyIban: '',
      keyBBAN: '',
      IDBank: '',
      IDBranch: '',
      accountNumber: '',
      ibanNationalID: '',
      nationnalID: '',
      BIC: '',
      institutionName: '',
      branchInformation: '',
      address1: '',
      address2: '',
      address3: '',
      address4: '',
      city: '',
      zipCode: '',
      Cps: '',
      country: '',
      ISOCountryCode: '',
      institutionParentName: '',
      parentBic: '',
      form: {
        name: '',
        iban: '',
        business: '',
        reference: '',
        businessReferenceType: '',
        entrepriseIdentifierName: '',
        entrepriseIdentifierType: ''
      },
      typeList: {
        BANK: true,
        CBID: true,
        CHID: true,
        CINC: true,
        COID: true,
        CUST: true,
        DUNS: true,
        EMPL: true,
        GS1G: true,
        SREN: true,
        SRET: true,
        TXID: true,
        BDID: true,
        BOID: true,
        LEIC: true,
        EUID: true,
        BICC: true,
      },
      // Propriétés ajoutées pour éviter les warnings Vue
      identifier: null,
      type: null,
      label: null,
    }
  },
  watch: {
    'form.iban': function(newIban, oldIban) {
      if (newIban && this.verifierIBAN(newIban)) {
        this.controlIban(newIban)
      }
    }
  },
  computed: {
    isFormValid() {
      // Validation simple sans modification d'état pour le bouton
      const ibanValid = this.verifierIBAN(this.form.iban.trim()) && this.form.iban.trim() !== ''
      const identifierValid = this.form.entrepriseIdentifierName !== ''
      
      // Pas de validation sur le type car il peut être vide (pour le type "nom")
      return ibanValid && identifierValid && this.corporateIdentifierTypesMatch
    },
    hasIdentifierTypeError() {
      return this.getFormErrors('identifier-type').length > 0
    },
    hasIdentifierInputError() {
      return this.getFormErrors('identifier-input').length > 0
    },
    identifierTypeErrors() {
      return this.getFormErrors('identifier-type')
    }
  },
  created () {
  },
  methods: {
    controlIban (iban) {
      this.ibanFind = false
      this.corporateIdentifierTypesMatch = false
      if (iban) {
        let that = this
        this.$engine.firstOn().tracking.getVerifIban({IBAN: iban.toUpperCase().replace(/\s+/g, '').trim()}
        ).then(resp => {

          that.ibanFind = true
          that.format = resp.data.format
          that.keyIban = resp.data.keyIban
          that.keyBBAN = resp.data.keyBBAN
          that.IDBank = resp.data.IDBank
          that.IDBranch = resp.data.IDBranch
          that.accountNumber = resp.data.accountNumber
          that.ibanNationalID = resp.data.ibanNationalID
          that.nationnalID = resp.data.nationnalID
          that.BIC = resp.data.BIC
          that.institutionName = resp.data.institutionName
          that.branchInformation = resp.data.branchInformation
          that.address1 = resp.data.address1
          that.address2 = resp.data.address2
          that.address3 = resp.data.address3
          that.address4 = resp.data.address4
          that.city = resp.data.city
          that.zipCode = resp.data.zipCode
          that.country = resp.data.country
          that.ISOCountryCode = resp.data.ISOCountryCode
          that.institutionParentName = resp.data.institutionParentName
          that.parentBic = resp.data.parentBic

          Object.keys(that.typeList).forEach(key => {
            that.typeList[key] = true
          })

          if (resp.data.bankReachable === 1) {
            that.corporateIdentifierTypesMatch = true
            resp.data.corporateIdentifierTypes.forEach(identifier => {
              if (that.typeList.hasOwnProperty(identifier.Name)) {
                that.typeList[identifier.Name] = false
              }
            })
          } else {
            let error = {response: {
                status: 404,
                data : {
                  error: this.$t('common.bic.bic_not_found'),
                  errorDescription: this.$t('common.bic.bic_not_found_description')
                }
              }}
            errorMessageAlert(error, that)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    verifierIBAN (iban) {
      if (this.form.entrepriseIdentifierType !== '') {
        if (this.typeList[this.form.entrepriseIdentifierType] == true) {
          this.form.entrepriseIdentifierType = ''
        }
      }
      iban = iban.replace(/\s+/g, '').toUpperCase()

      const longueurIBAN = {
        AD: 24, AE: 23, AL: 28, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
        CH: 21, CR: 22, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, FI: 18,
        FO: 18, FR: 27, GB: 22, GE: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21, HU: 28,
        IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, LC: 32, LI: 21,
        LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, MT: 31, MU: 30,
        NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, RO: 24, RS: 22, SA: 24,
        SC: 31, SE: 24, SI: 19, SK: 24, SM: 27, ST: 25, SV: 28, TL: 23, TN: 24, TR: 26,
        UA: 29, VA: 22, VG: 24, XK: 20
      }

      const codePays = iban.slice(0, 2)
      const longueurAttendue = longueurIBAN[codePays]

      if (!longueurAttendue || iban.length !== longueurAttendue) {
        return false
      }

      const ibanReforme = iban.slice(4) + iban.slice(0, 4)

      const ibanNumerique = ibanReforme.replace(/[A-Z]/g, char => char.charCodeAt(0) - 55)

      let reste = ''
      for (let i = 0; i < ibanNumerique.length; i += 7) {
        reste = String(parseInt(reste + ibanNumerique.slice(i, i + 7), 10) % 97)
      }

      return parseInt(reste, 10) === 1
    },
    addTracking () {
      if (this.validateFormAccessible()) {

        let form = {
          Reference: this.form.reference,
          BIC: this.BIC,
          IBAN: this.form.iban.trim()
        }

        if (this.form.entrepriseIdentifierType === '') {
          form.Name = this.form.entrepriseIdentifierName
        } else {
          form.EnterpriseType = this.form.entrepriseIdentifierType
          form.Identifier = this.form.entrepriseIdentifierName
        }

        this.activateSpinner = true
        this.$f7.showPreloader(this.$i18n.t('tracking.ddv_sending'))
        let that = this
        this.$engine.firstOn().tracking.create(form)
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$t('tracking.ddv_sent'),
            text: '<i class="icon fa-solid fa-check text-dark" aria-hidden="true"></i><span class="sr-only">' + that.$t('common.success') + '</span>'
          })
          setTimeout(function () {
            that.activateSpinner = false
            that.$f7.closeModal()
            loadPage(that, { url: '/tracking/DDV/NULL' })
            // loadPage(that, { url: '/trackingdetails/DDV/' + resp.data.Reference })
          }, 3000)
        })
        .catch(e => {
          that.activateSpinner = false
          errorMessageAlert(e, that)
        })
      }
    },
    
    getFormErrors(fieldId) {
      return this.formErrors.filter(error => error.field === fieldId)
    },
    
    clearFormErrors() {
      this.formErrors = []
    },
    
    addFormError(fieldId, message) {
      // Remove existing error for this field
      this.formErrors = this.formErrors.filter(error => error.field !== fieldId)
      // Add new error
      this.formErrors.push({
        field: fieldId,
        message: message
      })
    },
    
    validateFormAccessible(showAlert = true) {
      this.clearFormErrors()
      
      // Validate IBAN
      if (!this.verifierIBAN(this.form.iban.trim()) || this.form.iban.trim() === '') {
        this.addFormError('iban-input', this.$i18n.t('errors.chng_the_iban_to_vld_frmt'))
      }
      
      // Validate identifier
      if (this.form.entrepriseIdentifierName === '') {
        this.addFormError('identifier-input', this.$i18n.t('errors.miss_id'))
      }
      
      // Validate identifier type - Removed because empty value is valid (represents "Nom")
      
      if (this.formErrors.length > 0) {
        if (showAlert) {
          this.$nextTick(() => {
            // Focus on error summary
            const errorSummary = document.getElementById('error-summary')
            if (errorSummary) {
              errorSummary.focus()
            }
            
            // Set aria-invalid on fields
            this.formErrors.forEach(error => {
              const field = document.getElementById(error.field)
              if (field) {
                field.setAttribute('aria-invalid', 'true')
              }
            })
          })
        }
        return false
      }
      
      // Clear aria-invalid from all fields if validation passes
      this.$nextTick(() => {
        const fields = ['iban-input', 'identifier-input', 'identifier-type']
        fields.forEach(fieldId => {
          const field = document.getElementById(fieldId)
          if (field) {
            field.setAttribute('aria-invalid', 'false')
          }
        })
      })
      
      return true
    }
  }
}
</script>

<style scoped>
/* Focus visible amélioré - nécessaire pour l'accessibilité */
.form-control:focus,
.btn:focus,
button:focus,
select:focus,
input:focus {
  outline: 3px solid #0066cc;
  outline-offset: 2px;
}

/* Lien d'évitement - styles spécifiques pour l'accessibilité */
.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: #000;
  color: #fff;
  padding: 8px;
  text-decoration: none;
  z-index: 1000;
  border-radius: 4px;
}

.skip-link:focus {
  top: 6px;
  outline: 3px solid #0066cc;
  outline-offset: 2px;
}

/* Table container responsive - nécessaire pour le défilement */
.custom-table-container {
  max-height: 400px;
  overflow-y: auto;
}

.custom-table-container thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
}

/* Caption intégré au tableau */
.custom-table-container table caption {
  caption-side: top;
  border: 1px solid #dee2e6;
  border-bottom: 0;
  border-radius: 0.25rem 0.25rem 0 0;
}

/* Classes personnalisées pour le bouton avec contraste garanti */
.btn-turquoise {
  background-color: #0a7a79;
  border-color: #0a7a79;
  color: #ffffff;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
}

.btn-turquoise:hover:not(:disabled) {
  background-color: #086665;
  border-color: #086665;
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-turquoise:active:not(:disabled) {
  background-color: #075554;
  border-color: #075554;
  color: #ffffff;
  transform: translateY(0);
}

.btn-turquoise-disabled {
  background-color: #5a6268;
  border-color: #5a6268;
  color: #ffffff;
  opacity: 1;
  cursor: not-allowed;
}

/* S'assurer que tous les éléments enfants héritent de la couleur blanche */
.btn-turquoise span,
.btn-turquoise i,
.btn-turquoise-disabled span,
.btn-turquoise-disabled i,
.btn-turquoise .spinner-border,
.btn-turquoise-disabled .spinner-border {
  color: inherit;
}

/* Forcer la couleur blanche sur les éléments avec la classe text-white */
.text-white {
  color: #ffffff !important;
}

/* S'assurer que les spans dans les boutons n'ont pas de fond propre */
.btn span,
button span {
  background-color: transparent !important;
  background: transparent !important;
}
</style>
